import {Container} from "./Container"

export const NotFoundPageStyled = {
    Container: Container
}